export function formatDate(time, fmt) {
  if (time === undefined || '') {
    return
  }
  const date = new Date(time)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function watch_record_format(val) {
  const num = Number(val)
  if (num < 60) {
    return '不足1分钟'
  } else if (num >= 60 && num < 3600) {
    const m = Math.floor(num / 60)
    return `${m}分钟`
  } else if (num >= 3600) {
    const h = Math.floor(num / 3600)
    const m = Math.floor((num % 3600) / 60)
    return `${h}小时${m}分钟`
  }
}

export function format_Date(val) {
  return formatDate(new Date(val), 'yyyy-MM-dd')
}

export function format_Date_a(val) {
  return formatDate(new Date(val), 'hh:mm')
}

export function format_Date_b(val) {
  return formatDate(new Date(val), 'MM-dd hh:mm')
}

export function format_Date_c(val) {
  return formatDate(new Date(val), 'yyyy-MM-dd hh:mm')
}
